import { FC } from 'react'
import DashboardIcon from '@mui/icons-material/Dashboard'
import LeaderboardIcon from '@mui/icons-material/Leaderboard'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import FeedIcon from '@mui/icons-material/Feed'
import Dashboard from './features/dashboard/Dashboard'
import Customers from './features/customers/Customers'
import OperationsExecutive from './features/operationsExecutive/OperationsExecutive'
import InvestigatingOfficer from './features/investigatingOfficer/InvestigatingOfficer'
import CustomerDetailTabs from './features/investigatingOfficer/CustomerDetailTabs'
import Leads from './features/leads/Leads'
import OrderSummary from './features/orderSummary/OrderSummary'
import SummarizeIcon from '@mui/icons-material/Summarize'
import DomainVerificationIcon from '@mui/icons-material/DomainVerification'
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter'
import Users from './features/users/Users'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import LabTest from './features/labTest/LabTest'
import { ReactComponent as TestTubeIcon } from './assets/icons/TestTube.svg'
import ListAltIcon from '@mui/icons-material/ListAlt'
import PolicyInformation from './features/policyInformation/PolicyInformation'

interface Route {
  key: string
  title: string
  path: string
  enabled: boolean
  component: FC<unknown>
  index: number
  icon: FC<{ fontSize?: 'small' | 'medium' | 'large' }>
}

export const routes: Array<Route> = [
  {
    key: 'dashboard',
    title: 'Dashboard',
    path: `${process.env.PUBLIC_URL}/dashboard`,
    enabled: true,
    index: 0,
    icon: DashboardIcon,
    component: Dashboard,
  },
  {
    key: 'leads',
    title: 'Leads',
    path: `${process.env.PUBLIC_URL}/leads`,
    enabled: true,
    index: 1,
    icon: LeaderboardIcon,
    component: Leads,
  },
  {
    key: 'customers',
    title: 'Customers',
    path: `${process.env.PUBLIC_URL}/customers`,
    enabled: true,
    index: 2,
    icon: PeopleAltIcon,
    component: Customers,
  },
  {
    key: 'orderSummary',
    title: 'Order Summary',
    path: `${process.env.PUBLIC_URL}/orderSummary`,
    enabled: true,
    index: 3,
    icon: SummarizeIcon,
    component: OrderSummary,
  },
  {
    key: 'operationsExecutive',
    title: 'Operations Executive',
    path: `${process.env.PUBLIC_URL}/operationsExecutive`,
    enabled: true,
    index: 4,
    icon: BusinessCenterIcon,
    component: OperationsExecutive,
  },
  {
    key: 'investigatingOfficer',
    title: 'Investigating Officer',
    path: `${process.env.PUBLIC_URL}/investigatingOfficer`,
    enabled: true,
    index: 5,
    icon: DomainVerificationIcon,
    component: InvestigatingOfficer,
  },
  {
    key: 'labtest',
    title: 'Lab Test',
    path: `${process.env.PUBLIC_URL}/labTest`,
    enabled: true,
    index: 6,
    icon: TestTubeIcon,
    component: LabTest,
  },

  {
    key: 'users',
    title: 'Users',
    path: `${process.env.PUBLIC_URL}/users`,
    enabled: true,
    index: 7,
    icon: AccountCircleIcon,
    component: Users,
  },
  {
    key: 'policyInformation',
    title: 'Policy Information',
    path: `${process.env.PUBLIC_URL}/policyInformation`,
    enabled: true,
    index: 8,
    icon: ListAltIcon,
    component: PolicyInformation,
  },

  {
    key: 'customerDetails',
    title: 'Customer Details',
    path: `${process.env.PUBLIC_URL}/customerDetails`,
    enabled: true,
    index: 9,
    icon: FeedIcon,
    component: CustomerDetailTabs,
  },
  /* Add additional routes in Routes.ts as required following the above format: */
]
